"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const noop_1 = __importDefault(require("lodash/noop"));
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const util_theme_sxc_1 = require("@hotelplan/util.theme.sxc");
function preventDefault(e) {
    e.preventDefault();
}
const AutocompleteSuggestionItem = styled_components_1.default.li(({ theme, active }) => (0, util_theme_sxc_1.sx2CssTheme)(theme, {
    cursor: [null, `pointer`],
    py: [1, 2],
    outline: '1px transparent dotted',
    outlineColor: active ? 'accentColor' : 'transparent',
}));
const AutocompleteSuggestion = (_a) => {
    var { active, children, onClick = noop_1.default } = _a, liProps = __rest(_a, ["active", "children", "onClick"]);
    return (react_1.default.createElement(AutocompleteSuggestionItem, Object.assign({ as: "li", active: active }, liProps, { tabIndex: -1, role: "option", onClick: onClick, 
        // Prevent losing focus after clicking element
        onMouseDown: preventDefault, "data-id": "autocomplete-option" }), children));
};
exports.default = AutocompleteSuggestion;
//# sourceMappingURL=AutocompleteSuggestion.js.map